import { useBehavior, useButton, useTriggerAction } from '@libs/core';
import { TWidgetProps } from '@libs/types';
import React from 'react';
import { TCoreButtonData } from '../types/data';
import { TCoreButtonOptions } from '../types/options';
import { CoreButtonView } from './CoreButtonView';

/**
 * Standalone button widget driven entirely by server-provided configuration.
 * Owns behavior hooks (useBehavior, useButton) and delegates rendering to CoreButtonView.
 *
 * Use this component when the widget definition comes from the server and no
 * additional style overrides are required.
 */
const CoreButtonWidget = ({ widget, children }: React.PropsWithChildren<TWidgetProps<TCoreButtonData, TCoreButtonOptions>>) => {
    const { isDisabled, isHidden } = useBehavior(widget);
    const { triggerActionsByType, triggerActionsByNameAndType } = useTriggerAction(widget);
    const { handleClick } = useButton(widget, { isDisabled, triggerActionsByType, triggerActionsByNameAndType });

    return (
        <CoreButtonView
            widget={widget}
            isDisabled={isDisabled}
            isHide={isHidden}
            onClick={handleClick}
            text={widget.data?.text}
            styleName={widget.options?.style}
        >
            {children}
        </CoreButtonView>
    );
};

export { CoreButtonWidget };
